import React from 'react';
import Header from './components/Header_afzal';
import Header_afzal from './components/Header_afzal_minimalis';
import Footer from './components/Footer';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import DeliveryInReport from './screens/DeliveryInReport';
import {Container,Card,Grid} from '@mui/material';
import { BrowserRouter as Router ,Route } from 'react-router-dom';
import BottomAppBar from './screens/BottomAppBar';
import PenerimaanScreen from './screens/PenerimaanScreen';
import HomeScreenGuest from './screens/HomeScreenGuest';
import Dashboard from './screens/DashboardAdmin';
import DeliveryInNote from './screens/DeliveryInNote';
import { makeStyles } from '@mui/styles';
import { ClassNames } from '@emotion/react';
import { CssBaseline } from '@mui/material';

const useStyles = makeStyles({
  root: {
    // minHeight:'100vh',
    paddingTop: 0,
    backgroundImage: "url(/images/assets/bg.jpg)",
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',

  },
});

const App = () => {
  const classes = useStyles()
  return (
    // <div className={classes.root}>
    <Router>

    <Header/>
    <main>
      <CssBaseline />
      {/* <Container sx={{ mt: 8 }} maxWidth="xl"  className={classes.root}> */}
      <div sx={{ mt: 0,mx:0 }} maxWidth="xl"  >
        {/* <Route path='/' component={HomeScreenGuest} exact/> */}
        {/* <Route path='/' component={ProductScreen} exact/> */}
        <Route path='/' component={DeliveryInNote} exact/>
        
        <Route path='/product/:id' component={ProductScreen}/>
        <Route path='/cart/:id?' component={CartScreen} /> 
        <Route path='/login' component={LoginScreen}/>
        <Route path='/register' component={RegisterScreen}/>
        <Route path='/dashboard' component={Dashboard}/>
        <Route path='/DeliveryIn' component={DeliveryInNote}/>
        {/* <Route path='/login' component={LoginScreen} />
        <Route path='/product/:id' component={ProductScreen}/>
        <Route path='/cart/:id?' component={CartScreen} /> */}
      </div>
    </main>

    <Footer/>
    </Router>
    // </div>
  )
}

export default App;